import cn from 'clsx'
import {
  DetailedHTMLProps,
  forwardRef,
  HTMLAttributes,
  useEffect,
  useRef,
  useState,
} from 'react'
import styles from './Section.module.scss'

type SectionProps = {
  disableFadeUp?: boolean
  container?: boolean
  sectionClasseName?: string
}

const Section = forwardRef<
  HTMLDivElement,
  SectionProps &
    DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
>(({ disableFadeUp, container, sectionClasseName, children, ...args }, ref) => {
  const [isVisible, setVisible] = useState(false)
  const [viewed, setViewed] = useState(false)
  const domRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => setVisible(entry.isIntersecting))
    })

    observer.observe(domRef.current!)

    return () => {
      observer.disconnect()
    }
  }, [domRef, domRef.current])

  useEffect(() => {
    if (isVisible) setViewed(true)
  }, [isVisible])

  return (
    <div
      ref={domRef}
      style={args.style}
      className={cn('relative mx-auto', sectionClasseName, {
        container: container,
        [styles.root]: !disableFadeUp,
        [styles.visible]: viewed,
      })}
    >
      <div ref={ref} {...args}>
        {children}
      </div>
    </div>
  )
})

Section.displayName = 'Section'

export default Section
